import { standardStringSchema, trimmedStringSchema, urlSchema } from "@/schemas"
import { z } from "zod"

import type { ProviderSelection } from "./provider-selection"
import { providerSelectionSchema } from "./provider-selection"

export interface CreateCredentialFormValues {
  notes: string
  password: string
  provider: ProviderSelection | null
  resources: string[]
  username: string
  website: string
}

export const createCredentialSchema = z.object({
  // Multiline operational notes routinely exceed defaultMaxLength.
  notes: trimmedStringSchema,
  // Utility vault secret: no max; do not use passwordSchema (min 12).
  password: trimmedStringSchema.min(1),
  provider: providerSelectionSchema,
  resources: z
    .array(standardStringSchema.min(1))
    .min(1)
    .transform((resources) => [...new Set(resources)]),
  username: standardStringSchema.min(1),
  website: urlSchema,
})

export type CreateCredentialSchema = z.infer<typeof createCredentialSchema>
